export const keysToCompare = [
  "pins",
  "id",
  "name",
  "description",
  "options",
  "settings",
  "blocks",
];
